'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Career = undefined;

var _templateObject = _taggedTemplateLiteral(['\n    display: grid;\n    grid-template-rows: auto 1fr;\n    text-align: center;\n    background-color: white;\n    border-radius: 5px;\n    color: #42474D;\n\n    & ', ' {\n      font-size: 1.2em;\n    }\n\n    & > img {\n        grid-column-start: 1;\n        grid-row-start: 1;\n\n        &:nth-child(1) {\n            width: 100%;\n            overflow: hidden;\n            margin-bottom: 50px;\n            border-radius: 4px 4px 0 0;\n        }\n        &:nth-child(2) {\n            align-self: end;\n            justify-self: center;\n        }\n    }\n    & > div {\n        padding: 20px;\n        & > small {\n            line-height: 2.5em;\n            color: #7F8A94;\n        }\n    }\n'], ['\n    display: grid;\n    grid-template-rows: auto 1fr;\n    text-align: center;\n    background-color: white;\n    border-radius: 5px;\n    color: #42474D;\n\n    & ', ' {\n      font-size: 1.2em;\n    }\n\n    & > img {\n        grid-column-start: 1;\n        grid-row-start: 1;\n\n        &:nth-child(1) {\n            width: 100%;\n            overflow: hidden;\n            margin-bottom: 50px;\n            border-radius: 4px 4px 0 0;\n        }\n        &:nth-child(2) {\n            align-self: end;\n            justify-self: center;\n        }\n    }\n    & > div {\n        padding: 20px;\n        & > small {\n            line-height: 2.5em;\n            color: #7F8A94;\n        }\n    }\n']);

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _SectionTitle = require('./SectionTitle');

var _LazyImg = require('./LazyImg');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
/*:: import type {ComponentType} from 'react' */


/*::
type Props = {|
    className?: string,
    background: string,
    name: string,
    image: string,
    courses: string,
    children: React.Node,
|}
*/
var Career /*: ComponentType<Props> */ = exports.Career = (0, _styledComponents2.default)(function (props) {
    return React.createElement(
        'div',
        { className: props.className, onClick: props.onClick },
        React.createElement(_LazyImg.LazyImg, { src: props.background + '?size=352x90s&ext=jpg&lightness=-25',
            height: 90,
            alt: props.name }),
        React.createElement(_LazyImg.LazyImg, { src: props.image, width: '100', alt: props.name }),
        React.createElement(
            'div',
            null,
            React.createElement(
                _SectionTitle.SectionTitle.h3,
                null,
                props.name
            ),
            React.createElement(
                'small',
                null,
                props.courses
            ),
            React.createElement(
                'p',
                null,
                props.children
            )
        )
    );
})(_templateObject, _SectionTitle.SectionTitle.h3);
Career.displayName = 'Career';


//////////////////
// WEBPACK FOOTER
// ../tutellus-ui/lib/Career.js
// module id = 600
// module chunks = 0